import { connect } from "react-redux";
import { getInLanDongLai } from "actions/InLanDongLai";
import CamDo from "components/CommonComponent/InLanThanhToan";

const mapStateToProps = (state) => ({
  inlandonglai: state.inlandonglai,
});

const mapDispatchToProps = (dispatch) => ({
  getInLanDongLai: (dataSearch) => dispatch(getInLanDongLai(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CamDo);
